import { ListItemButton, Stack, SxProps, Typography } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import Image from "src/components/Image";
import { ConnectedEntity } from "src/types/apps";
import { entitiesUrl } from "src/utils/formatUrl";

import Context from "../../context";

// ----------------------------------------------------------------------

type Props = {
	item: ConnectedEntity;
};

const sx: SxProps = {
	borderRadius: 1,
	px: 2,
	py: 1,
	mx: 1,
	my: 0.5,
	justifyContent: "space-between",
	boxShadow: 1
};

export const EntityItemMobile = ({ item }: Props) => {
	const { actions } = useContext(Context);

	return (
		<ListItemButton key={item.id} onClick={() => actions.onSelectEntity(item)} sx={sx}>
			<Stack flexDirection={"row"} alignItems={"center"}>
				<Image
					src={entitiesUrl(item.id)}
					sx={{ width: 40, height: 40, alignSelf: "flex-start" }}
					fit='contain'
				/>
				<Typography variant='subtitle2' sx={{ ml: 2 }}>
					{item.name}
				</Typography>
			</Stack>
			<Iconify icon={"iconamoon:arrow-right-2"} color='text.secondary' />
		</ListItemButton>
	);
};

export default EntityItemMobile;
